// extracted by mini-css-extract-plugin
export var address = "footer-module--address--e2a32";
export var arrow = "footer-module--arrow--d98a4";
export var button = "footer-module--button--8d64a";
export var copyright = "footer-module--copyright--b80ae";
export var dropdown = "footer-module--dropdown--3dc55";
export var footSubMenu = "footer-module--footSubMenu--66ae3";
export var footer = "footer-module--footer--38d87";
export var footerLogos = "footer-module--footer-logos--fab31";
export var footerLogosAccs = "footer-module--footer-logos-accs--ce65b";
export var footnote = "footer-module--footnote--fe0d3";
export var inner = "footer-module--inner--ce2e2";
export var logo = "footer-module--logo--7717e";
export var menu = "footer-module--menu--f65fc";
export var menuLink = "footer-module--menuLink--26738";
export var navList = "footer-module--navList--c17dc";
export var navTitle = "footer-module--navTitle--d8a6f";
export var row = "footer-module--row--6480f";
export var social = "footer-module--social--41ed0";
export var subMenu = "footer-module--subMenu--20a3b";
export var subMenuItem = "footer-module--subMenuItem--925dd";
export var subMenuLink = "footer-module--subMenuLink--6cf9a";
export var text = "footer-module--text--2d2c5";